module.exports = __webpack_public_path__ + "static/media/mydrap2_1.53384f46.jpg";